/* @flow */
import cx from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
import ReactDOM from 'react-dom';

import './styles/View.scss';

/**
 * ```example
 * <View>
 *   Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt
 *   ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation
 *   ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in
 *   reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.
 * </View>
 * ```
 *
 * ```example
 * <View gutter="small">
 *   Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt
 *   ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation
 *   ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in
 *   reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.
 * </View>
 * ```
 *
 * ```example
 * <View full>
 *   Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt
 *   ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation
 *   ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in
 *   reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.
 * </View>
 * ```
 */

class View extends React.Component<$FlowFixMeProps, $FlowFixMeState> {
  static propTypes = {
    /** Vertically center content (on load) */
    center: PropTypes.bool,
    /** Remove `padding` */
    full: PropTypes.bool,
    /** Increase/reduce `padding` */
    gutter: PropTypes.oneOf(['medium', 'small']),
    /** Scroll when content exceeds parent height */
    scroll: PropTypes.bool,
  };

  state = {
    paddingTop: 0,
  };

  componentDidMount() {
    if (this.props.center) {
      this.centerContent();
    }
  }

  centerContent = () => {
    const root = ReactDOM.findDOMNode(this);
    const content = ReactDOM.findDOMNode(this.refs.content);
    // $FlowFixMe
    const offsetTop = (root.offsetHeight - content.offsetHeight) / 2;

    this.setState({ paddingTop: offsetTop });
  };

  renderBody() {
    const { children, center } = this.props;
    const { paddingTop } = this.state;

    if (center) {
      return (
        <div style={{ paddingTop }} className="View-inner">
          <div ref="content">{children}</div>
        </div>
      );
    } else {
      return children;
    }
  }

  render() {
    // eslint-disable-next-line no-unused-vars
    const { center, children, className, full, gutter, scroll, ...props } = this.props;

    return (
      <div
        {...props}
        className={cx('View', gutter && `View--gutter--${gutter}`, className, {
          'View--center': center,
          'View--full': full,
          'View--scroll': scroll,
        })}>
        {this.renderBody()}
      </div>
    );
  }
}

export default View;
